import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* 公司信息 */}
          <div className="col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/logo.png" alt="Logo" className="w-8 h-8" />
              <span className="text-xl font-bold text-white">杭州光智云</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              杭州光智云软件有限公司专注于光学智能算法，致力于光学软件研发的高新技术公司。
              基于物理机理进行智能信息处理，将传统光学和现代AI技术充分融合。
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">0571-58837995  & 19706826782</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">contact@hzgzyrj.cn</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">杭州市富阳区大源镇塘子畈街200号</span>
              </div>
              <div className="flex items-center space-x-2">
                <img src="/images/备案.png" alt="备案图标" className="w-4 h-4" />
                <span className="text-gray-300">浙ICP备2022005250号-1</span>
              </div>
            </div>
          </div>

          {/* 产品链接 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">产品</h3>
            <ul className="space-y-2">
              <li>
                <a
                    // href="http://seeod.net/"
                    className="text-gray-300 hover:text-white transition-colors"
                    target="_blank"  // 可选：添加这行会在新标签页打开
                    rel="noopener noreferrer" // 可选：配合 target="_blank" 使用，安全最佳实践
                >
                  几何光学仿真
                </a>
              </li>
              {/*<li>*/}
              {/*  <Link to="/products" className="text-gray-300 hover:text-white transition-colors">*/}
              {/*    SeeLight物理光学仿真*/}
              {/*  </Link>*/}
              {/*</li>*/}
              <li>
                <a
                    href="http://seetf.oai.com.cn"
                    className="text-gray-300 hover:text-white transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  光学薄膜系统优化设计软件
                </a>
              </li>
            </ul>
          </div>

          {/* 支持链接 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">支持</h3>
            <ul className="space-y-2">
              {/* <li>
                <Link to="/manual" className="text-gray-300 hover:text-white transition-colors">
                  参考手册
                </Link>
              </li> */}
              <li>
              <Link to="/cases" className="text-gray-300 hover:text-white transition-colors">
                  案例展示
                </Link>
              </li>
              {/* <li>
                <Link to="/community" className="text-gray-300 hover:text-white transition-colors">
                  社区
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          {/* 二维码 */}
          <div className="text-center">
            <p className="text-gray-400 text-sm mb-2">关注我们</p>
            <img 
              src="/images/wx.jpg" 
              alt="微信公众号二维码" 
              className="w-20 h-20 border border-gray-600 rounded mx-auto"
            />
            <p className="text-gray-400 text-xs mt-1">扫码关注公众号</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 杭州光智云软件有限公司. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
